import React from 'react';

function ReviewSection({ title, color, children, style }) {
  return (
    <div style={{ background: "rgba(20,16,10,0.6)", border: `1px solid ${color}22`, borderRadius: 8, padding: "12px 14px", ...style }}>
      <div style={{ fontFamily: "'Cinzel', serif", fontSize: "11px", color, letterSpacing: 1, textTransform: "uppercase", marginBottom: 8 }}>
        {title}
      </div>
      {children}
    </div>
  );
}

export default ReviewSection;
